(function () {
  const params = new URLSearchParams(window.location.search);
  const config = window.userLoginRedirectConfig || {};
  const shopId = config.shopId;

  if (!shopId) return;

  // Skip the cart page: checkout adds ?logged_in=true there, which is not a login redirect.
  const isCartPage = /(^|\/)cart(\/|$)/.test(window.location.pathname);
  if (isCartPage) return;

  // URL param approach (Shop app login and standard new-account redirect)
  if (params.get('shop_sign_in') === 'true' || params.get('logged_in') === 'true') {
    window.location.replace(`https://shopify.com/${shopId}/account/profile`);
    return;
  }

  // sessionStorage approach: detect login state change across page navigations
  // Only fires when we explicitly know the customer was logged OUT on a previous
  // page in this tab session (prevLoggedIn === 'false'), not on a fresh tab open.
  const isLoggedIn = config.isLoggedIn === true;
  const prevLoggedIn = sessionStorage.getItem('customerLoggedIn');

  if (isLoggedIn && prevLoggedIn === 'false') {
    sessionStorage.setItem('customerLoggedIn', 'true');
    window.location.replace(`https://shopify.com/${shopId}/account/profile`);
  } else {
    sessionStorage.setItem('customerLoggedIn', String(isLoggedIn));
  }
})();
